/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 */
import Reveal from "./Reveal";
import { DOMAINS } from "./landing.data";

export default function DomainsSection({ isArabic }) {
  return (
    <section className="gl-section" id="domains">
      <div className="gl-shell">
        <Reveal className="gl-head">
          <p className="gl-eyebrow">
            {isArabic ? "المجالات" : "Industries"}
          </p>
          <h2 className="gl-title">
            {isArabic
              ? "مجرتك التجارية بلا حدود"
              : "Your commerce galaxy has no borders"}
          </h2>
          <p className="gl-lead">
            {isArabic
              ? "من الأزياء إلى الإلكترونيات والخدمات — مدار يتكيّف مع قطاعك."
              : "From fashion to electronics and services — Madar adapts to your niche."}
          </p>
        </Reveal>

        <div className="gl-domains">
          {DOMAINS.map((d, i) => (
            <Reveal
              key={d.nameEn}
              delay={i * 0.05}
              className={`gl-domain gl-domain--${d.span}`}
            >
              <span className="gl-domain__emoji" aria-hidden="true">
                {d.emoji}
              </span>
              <span className="gl-domain__name">
                {isArabic ? d.nameAr : d.nameEn}
              </span>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
